module.exports = __webpack_public_path__ + "static/media/Entrenamiento_a_Vigilantes.452192a3.docx";